if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const wrapper = document.querySelector('[id*="media_with_content_RVymQU"] .media-block');

  if (wrapper) {
    const sparkles = [
      { top: '8%', left: '10%', delay: '0s', size: '18px' },
      { top: '18%', left: '82%', delay: '0.6s', size: '14px' },
      { top: '55%', left: '4%', delay: '1.2s', size: '16px' },
      { top: '70%', left: '88%', delay: '0.3s', size: '12px' },
    ];

    sparkles.forEach((pos) => {
      const sparkle = document.createElement('span');
      sparkle.className = 'hero-sparkle';
      sparkle.textContent = '🥜';
      sparkle.style.top = pos.top;
      sparkle.style.left = pos.left;
      sparkle.style.fontSize = pos.size;
      sparkle.style.animationDelay = pos.delay;
      wrapper.appendChild(sparkle);
    });
  }
}
